import React, { memo } from 'react';
import rubikaLogoSrc from '../../../assets/logos/roubica-logo.png';

export const RUBIKA_LOGO_SRC = rubikaLogoSrc;

function RubikaLogo({ width = 22, height = 22, alt = 'روبیکا', className = 'p-relative d-block', style }) {
  return (
    <img
      src={rubikaLogoSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={{ objectFit: 'contain', ...style }}
    />
  );
}

export default memo(RubikaLogo);
